export const intToIp = (ipAddress: number) => {
	return (ipAddress >>> 24) + "." + (ipAddress >> 16 & 255) + "." + (ipAddress >> 8 & 255) + "." + (ipAddress & 255);
};

export const ipToInt = (ipAddress: string) => {
	return ipAddress.split(".").reduce((ipInt, octet) => {
		return (ipInt << 8) + parseInt(octet, 10);
	}, 0) >>> 0;
};

export const generateIpWithOffset = (ipAddress: string, offset: number) => {
	return intToIp(ipToInt(ipAddress) + offset);
};
